import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_UPLOAD_STATUS } from 'domains/merchant-product/constants'

const propTypes = {
  photoUploadStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product `photo_upload_status`.
 * It maps `photo_edited_status` to certain style and pass to `StatusBadge`.
 * @param {string} photographyStatus
 */
const MerchantProductPhotoUploadStatusBadge = ({ photoUploadStatus }) => {

  const colorMap = {
    [PHOTO_UPLOAD_STATUS.PENDING]   : 'warning',
    [PHOTO_UPLOAD_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[photoUploadStatus] || 'default'

  return <StatusBadge color={ color } label={ photoUploadStatus } />
}

MerchantProductPhotoUploadStatusBadge.propTypes = propTypes

export default MerchantProductPhotoUploadStatusBadge
